import { actionLogout } from "app/modules/login/reducer/actions";
import auth from "app/shared/services/auth";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Pressable, StyleSheet, View } from "react-native";
import { Dialog, Paragraph, useTheme } from "react-native-paper";
import { useDispatch } from "react-redux";

const ExpiredAlertModal = () => {
  const { t } = useTranslation();
  const { colors, fonts } = useTheme();
  const accentColorStyle = { color: colors.accent };
  const buttonStyle = { ...fonts.medium };
  const dispatchStore = useDispatch();

  const onPressCloseToLogout = React.useCallback(() => {
    auth.logout();
    dispatchStore(actionLogout());
  }, [dispatchStore]);

  return (
    <View style={styles.container}>
      <Dialog.Title children={t("COMMON_THONG_BAO")} style={[accentColorStyle, styles.titleStyle]} />
      <Dialog.Content children={<Paragraph style={styles.messageStyle} children={t("COMMON_THONG_BAO_HET_PHIEN")} />} />
      <Dialog.Actions style={styles.actionStyle}>
        <Pressable onPress={onPressCloseToLogout}>
          <Paragraph style={[accentColorStyle, buttonStyle]} children={t("COMMON_DONG")} />
        </Pressable>
      </Dialog.Actions>
    </View>
  );
};

export default ExpiredAlertModal;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  titleStyle: {
    letterSpacing: 0,
    textAlign: "center",
  },
  textStyle: {
    textAlign: "center",
  },
  messageStyle: {
    color: "black",
    letterSpacing: 0,
    textAlign: "center",
  },
  actionStyle: {
    justifyContent: "center",
  },
});
